import {ForwardedRef, forwardRef} from 'react';
import * as Styled from './date-picker-input.styles';

interface DataPickerInputProps {
  value?: string;
  onChange?: () => void;
  className?: string;
  name: string;
  label: string;
  required?: boolean;
  placeholderText?: string;
  disabled?: boolean;
}

const DatePickerInput = forwardRef(
  (
    {value, onChange, className, name, label, required = true, disabled = false, ...props}: DataPickerInputProps,
    ref: ForwardedRef<HTMLInputElement>,
  ) => {
    return (
      <>
        <Styled.DatePickerLabel htmlFor={name}>{label}</Styled.DatePickerLabel>
        <Styled.DatePickerInput
          className={className}
          onChange={onChange}
          value={value}
          name={name}
          id={name}
          required={required}
          ref={ref}
          disabled={disabled}
          {...props}
        />
      </>
    );
  },
);

export default DatePickerInput;
